module.exports = __webpack_public_path__ + "img/more.df45893c.svg";